export default __webpack_public_path__ + "static/media/img_noData_taboola.d1114791.svg";